import styled from 'styled-components';

export const FormLabel = styled.label`
    display: block;
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
`;
